import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { SidebarContainer } from "../../../components";
import { Card } from "../../../shared";
import { DocumentTextIcon, ArrowRightIcon } from "@heroicons/react/24/outline";
import { buildHelpFeaturesPath } from "@/features/help-hub/help-links";

const UserGuide = () => {
  const navigate = useNavigate();
  const headerRef = useRef();
  const [headerContext, setHeaderContext] = useState();

  useEffect(() => {
    setHeaderContext(headerRef.current);
  }, [headerRef.current]);

  const renderTabHeader = (headerProps) => {
    return <div ref={headerRef}></div>;
  };

  const featureSections = [
    {
      title: "Jobs Management",
      description: "Learn how to create, manage, and track jobs in Attune",
      link: buildHelpFeaturesPath("jobs"),
      subsections: [
        { title: "Jobs section", link: buildHelpFeaturesPath("jobs") },
        { title: "Open jobs in app", link: "/jobs" },
        { title: "Dispatch board section", link: buildHelpFeaturesPath("dispatch") },
      ],
    },
    {
      title: "Client Management",
      description: "Manage customer information and relationships",
      link: buildHelpFeaturesPath("clients"),
      subsections: [
        { title: "Clients section", link: buildHelpFeaturesPath("clients") },
        { title: "Open clients in app", link: "/clients" },
        { title: "Feedback section", link: buildHelpFeaturesPath("feedback") },
      ],
    },
    {
      title: "Invoicing",
      description: "Track billing and payment workflow from draft to paid",
      link: buildHelpFeaturesPath("invoices"),
      subsections: [
        { title: "Invoices section", link: buildHelpFeaturesPath("invoices") },
        { title: "Open invoices in app", link: "/invoices" },
        { title: "Payouts section", link: buildHelpFeaturesPath("payouts") },
      ],
    },
    {
      title: "Operations Modules",
      description: "Review trucking and payout modules from one place",
      link: buildHelpFeaturesPath("manifests"),
      subsections: [
        { title: "Manifests section", link: buildHelpFeaturesPath("manifests") },
        { title: "Payouts section", link: buildHelpFeaturesPath("payouts") },
        { title: "Settings section", link: buildHelpFeaturesPath("settings-general") },
      ],
    },
  ];

  const handleSectionClick = (link) => {
    navigate(link);
  };

  return (
    <SidebarContainer hideSidebar header={renderTabHeader}>
      {({ parentHeight, parentWidth }) => {
        const offsetTop = headerContext?.offsetTop || 0;
        const offsetHeight = headerContext?.offsetHeight || 0;

        return (
          <div className="h-full overflow-y-auto w-full">
            <div className="w-full px-4 sm:px-6 lg:px-8 py-12">
              <div className="max-w-7xl mx-auto">
                <h1 className="text-4xl font-bold text-gray-900 mb-6">
                  User Guide
                </h1>
                <p className="text-xl text-gray-600 mb-12">
                  Comprehensive guide to all of Attune's features and
                  functionality
                </p>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {featureSections.map((section) => (
                    <Card
                      key={section.title}
                      className="p-6 hover:shadow-lg transition-shadow duration-200"
                    >
                      <div className="flex flex-col h-full">
                        <div className="flex items-center mb-4">
                          <DocumentTextIcon className="h-6 w-6 text-primary-600 mr-2" />
                          <h2 className="text-xl font-semibold text-gray-900">
                            {section.title}
                          </h2>
                        </div>
                        <p className="text-gray-600 mb-4">
                          {section.description}
                        </p>
                        <div className="mt-4 space-y-2">
                          {section.subsections.map((subsection) => (
                            <div
                              key={subsection.title}
                              className="flex items-center text-primary-600 hover:text-primary-800 cursor-pointer"
                              onClick={() =>
                                handleSectionClick(subsection.link)
                              }
                            >
                              <ArrowRightIcon className="h-4 w-4 mr-2" />
                              <span>{subsection.title}</span>
                            </div>
                          ))}
                        </div>
                      </div>
                    </Card>
                  ))}
                </div>
              </div>
            </div>
          </div>
        );
      }}
    </SidebarContainer>
  );
};

export default UserGuide;
